import React from 'react';
import { LABELS as DEFAULT_LABELS, PHONE_NUMBERS, FUNNELS } from '../../util/constants';
import { AddFunnelPropFromContext } from '../funnel-context';
import YesNoRadio from '../yes-no-radio';
const LABELS = {
  ARHI: DEFAULT_LABELS.DEPENDANTS_RADIO
};
const WORKERS_HELP = 'You can add a dependant if they are on the same visa as you, live at home, and are under 21 (or under 25 if they are in full or part-time study).';
const COMMON_HELP_TEXT = 'This includes all dependants up to the age of 21. To join with a student or adult dependant aged between 21 and up to 25, please call us on';
const HELP_TEXTS = {
  ARHI: `${COMMON_HELP_TEXT} ${PHONE_NUMBERS[FUNNELS.ARHI]}.`,
  APIA: `${COMMON_HELP_TEXT} ${PHONE_NUMBERS[FUNNELS.APIA]}.`,
  AAMI: `${COMMON_HELP_TEXT} ${PHONE_NUMBERS[FUNNELS.AAMI]}.`,
  SUNCORP: `${COMMON_HELP_TEXT} ${PHONE_NUMBERS[FUNNELS.SUNCORP]}.`,
  ING: `${COMMON_HELP_TEXT} ${PHONE_NUMBERS[FUNNELS.ING]}.`,
  PRICELINE: `${COMMON_HELP_TEXT} ${PHONE_NUMBERS[FUNNELS.PRICELINE]}.`,
  GU: `${COMMON_HELP_TEXT} ${PHONE_NUMBERS[FUNNELS.GU]}.`,
  IWHI: WORKERS_HELP,
  IMAN: WORKERS_HELP,
  ISHI: ''
};
export const DependantsGroupRadio = props => {
  const {
    funnel = FUNNELS.ARHI
  } = props;
  return React.createElement(YesNoRadio, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    help: props.help || HELP_TEXTS[funnel] || HELP_TEXTS.ARHI,
    funnel: funnel
  });
};
const DependantsGroupRadioWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(DependantsGroupRadio, {
  ...props
}));
export default DependantsGroupRadioWithFunnel;